import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  NoValue,
  MultiColumnList,
} from '@folio/stripes/components';
import {
  ASSIGN_TASK_FIELDS,
} from '../../../../../constants';
import { FolioFormattedDate } from '../../../../common';
import { getFormattedAssigned } from '../../../../../utils/get-formatted-assigned';

const visibleColumns = [
  ASSIGN_TASK_FIELDS.NAME,
  ASSIGN_TASK_FIELDS.ASSIGNED,
  ASSIGN_TASK_FIELDS.STATUS,
  ASSIGN_TASK_FIELDS.DUE_DATE,
];

const columnMapping = {
  [ASSIGN_TASK_FIELDS.NAME]: <FormattedMessage id="ui-task-list.job.assignTasks.field.name" />,
  [ASSIGN_TASK_FIELDS.ASSIGNED]: <FormattedMessage id="ui-task-list.job.assignTasks.field.assigned" />,
  [ASSIGN_TASK_FIELDS.STATUS]: <FormattedMessage id="ui-task-list.job.assignTasks.field.status" />,
  [ASSIGN_TASK_FIELDS.DUE_DATE]: <FormattedMessage id="ui-task-list.job.list.field.dueDate" />,
};

const resultsFormatter = {
  [ASSIGN_TASK_FIELDS.DUE_DATE]: (data) => (data[ASSIGN_TASK_FIELDS.DUE_DATE]
    ? <FolioFormattedDate value={data[ASSIGN_TASK_FIELDS.DUE_DATE]} />
    : <NoValue />
  ),
  [ASSIGN_TASK_FIELDS.ASSIGNED]: (data) => getFormattedAssigned(data),
  [ASSIGN_TASK_FIELDS.STATUS]: (data) => (
    <FormattedMessage id={`ui-task-list.task.statuses.${data[ASSIGN_TASK_FIELDS.STATUS]}`} />
  ),
};

const AssignTasks = ({ assignTask }) => (
  <Accordion
    id="assignTask"
    label={<FormattedMessage id="ui-task-list.title.accordion.assignTask" />}
  >
    <MultiColumnList
      columnMapping={columnMapping}
      contentData={assignTask}
      formatter={resultsFormatter}
      id="assignTaskList"
      visibleColumns={visibleColumns}
    />
  </Accordion>
);

AssignTasks.propTypes = {
  assignTask: PropTypes.arrayOf(PropTypes.object),
};

AssignTasks.defaultProps = {
  assignTask: [],
};

export default AssignTasks;
